export const aciFreeInternet = {
    iconName: 'free-internet',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.156 5.668a.833.833 0 00-.834.833v9.334a.5.5 0 11-1 0V6.5a1.833 1.833 0 011.834-1.833h14.666a1.833 1.833 0 011.834 1.833v9.334a.5.5 0 11-1 0V6.5a.833.833 0 00-.834-.833H5.156z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M1.988 15.836a.5.5 0 01.5-.5h7.703a.5.5 0 01.434.252 2.146 2.146 0 003.726 0 .5.5 0 01.434-.252h7.703a.5.5 0 01.5.5v1.333a3.166 3.166 0 01-3.166 3.167H5.155a3.167 3.167 0 01-3.167-3.167v-1.333zm1 .5v.833a2.167 2.167 0 002.167 2.167h14.667a2.167 2.167 0 002.166-2.167v-.833H15.06a3.144 3.144 0 01-5.141 0h-6.93zM12.487 12.41a.204.204 0 100-.409v-.59a.795.795 0 100 1.59v-.59z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M12.488 11.41a.795.795 0 110 1.591v-.59a.204.204 0 110-.41v-.59zM12.487 10.406c-.822 0-1.627.24-2.315.69a.5.5 0 01-.547-.838 5.233 5.233 0 015.725 0 .5.5 0 01-.547.838 4.233 4.233 0 00-2.316-.69z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.179 8.774a7.578 7.578 0 018.62 0 .5.5 0 01-.57.823 6.578 6.578 0 00-7.482 0 .5.5 0 01-.568-.823z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
